import React from 'react';
import { useSelector } from 'client/js/redux';
import { Icon, Tooltip } from '@branchjs/neo-components';
import styles from './ConflictIcon.styles';
import { selectAllColumns } from '../../../../main/selectors/Ads/AdsAnalyticsSelectors';

type OwnProps = {
  conflictingDimensionName: string;
  color?: string;
  relatedMetrics?: string[];
};

const ConflictIcon: React.FC<OwnProps> = ({ color, relatedMetrics = [], conflictingDimensionName }) => {
  const allColumns = useSelector(selectAllColumns);
  return (
    <div className={styles.wrapper} data-testid="conflict-icon">
      <Tooltip
        title={
          <div>
            This dimension has an incompatible aggregation with one currently added ({conflictingDimensionName}). To avoid
            values being set to 0, we suggest viewing separately.
            {relatedMetrics.length ? (
              <div className={styles.relatedMetrics}>
                <strong>Affected metrics: </strong>{' '}
                {relatedMetrics
                  .map((metric) => {
                    const column = allColumns.find((col) => col.reportColumnKey === metric);
                    return column?.display;
                  })
                  .join(', ')}
              </div>
            ) : null}
          </div>
        }
        placement="top"
      >
        <div className={styles.icon} style={{ color }}>
          <Icon>nearby_error</Icon>
        </div>
      </Tooltip>
    </div>
  );
};

export default ConflictIcon;
